<template>
    <div class="card">
        <div class="card-header">
            <div class="d-lg-flex justify-content-between">
                <h4 class="card-title d-flex mb-0">
                    <font-awesome-icon :icon="['far', 'question-circle']" />
                    <span class="text-muted ml-2">{{ question + 1 }}/{{ questions.length }}</span>
                    <div class="ml-2 text-truncate" :title="currentQuestion.title">
                        <span>{{ currentQuestion.title }}</span>
                    </div>
                </h4>
            </div>
        </div>
        <div class="body p-4">
            <blockquote class="blockquote text-center">„{{ questions[question].text }}“</blockquote>

            <div class="d-lg-flex justify-content-sm-between justify-content-md-around text-center" :key="question">
                <div class="text-center mt-3"><button @click="setAnswer(1)" class="btn btn-lg" :class="currentVote === 1 ? 'btn-success' : 'btn-outline-success'"><font-awesome-icon :icon="['fas', 'check']" /> stimme&nbsp;zu</button></div>
                <div class="text-center mt-3"><button @click="setAnswer(0)" class="btn btn-lg" :class="currentVote === 0 ? 'btn-secondary' : 'btn-outline-secondary'"> <font-awesome-icon :icon="['fas', 'equals']" /> neutral</button></div>
                <div class="text-center mt-3"><button @click="setAnswer(-1)" class="btn btn-lg" :class="currentVote === -1 ? 'btn-danger' : 'btn-outline-danger'"><font-awesome-icon :icon="['fas', 'times']" /> stimme&nbsp;nicht&nbsp;zu</button></div>
            </div>

            <div class="d-flex justify-content-between mt-4">
                <div class="mt-2 mr-2 text-left">
                    <button type="button" class="btn btn-light" @click="question--" v-if="question > 0">
                        <font-awesome-icon icon="arrow-left" fixed-width />
                        <span>vorherige Frage</span>
                    </button>
                </div>
                <div class="mt-2 ml-2 text-right">
                    <button type="button" class="btn btn-light" @click="next" v-if="question < questions.length">
                    <span v-if="currentVote === null">Frage überspringen</span>
                    <span v-else-if="question + 1 < questions.length">nächste Frage</span>
                    <span v-else>zur Gewichtung</span>
                    <font-awesome-icon icon="arrow-right" fixed-width />
                </button></div>
            </div>
        </div>
    </div>
</template>

<script>
import questions from '../data/questions';

export default {
    name: "MatQuestions",
    data() {
        return {
            questions,
            question: 0,
            answer: this.answer || Array(questions.length).fill(null),
            isStarted: false
        }
    },
    computed: {
        currentQuestion() {
            return this.questions[this.question]
        },
        currentVote() {
            return this.answer[this.question];
        },
        questionCount() {
            return this.questions.length;
        }
    },
    methods: {
        next() {
            if (1 + this.question < this.questions.length) {
                this.question++;
            } else if (this.answer) {
                this.$emit('forward');
            }
        },
        setAnswer(answer) {
            this.$set(this.answer, this.question, answer);
            this.next();
            this.$nextTick(() => {
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            });
        }
    },
    watch: {
        answer: {
            handler(value) {
                this.$emit('answer', value);
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>